<template>
  <div class="nauta-faq-detail-wrapper">
    <div class="nauta-faq-detail-content">
      <div class="nauta-faq-detail-navigation-container">
        <v-icon
          color="#333333"
          size="22"
          @click="$router.go(-1)"
        >
          mdi-arrow-left
        </v-icon>
        <span class="nauta-faq-detail-navigation-help" @click="displayHelpModal = true">
          {{$t('nautaMigration.help')}}
        </span>
      </div>
      <div class="nauta-faq-detail-item">
        <h2>{{$t(`nautaMigration.faq.${faqKey}.question`)}}</h2>
        <i18n :path="`nautaMigration.faq.${faqKey}.answer`" tag="p">
          <template v-slot:breakline>
            <br />
            <br />
          </template>
        </i18n>
      </div>
    </div>
    <NautaMigrationHelpModal
      class="help-modal"
      :value="displayHelpModal"
      @display="displayHelpModal = $event"
    />
  </div>
</template>

<script>
import NautaMigrationHelpModal from "@/components/migration/NautaMigrationHelpModal.vue";

export default {
  name: "NautaFaqDetail",

  data() {
    return {
      displayHelpModal: false,
    };
  },

  props: ["faqKey"],

  components: {
    NautaMigrationHelpModal,
  },

  methods: {

  },

};
</script>

<style lang="scss" scoped>

.nauta-faq-detail-wrapper{
  display: flex;
  justify-content: center;
  margin: 40px 20px;

  @media (max-width: 600px) {
    margin: 30px 20px;

  }
}

.nauta-faq-detail-content {
  max-width: 600px;
  width: 100%;
}

.nauta-faq-detail-navigation-container {
  display: flex;
  justify-content: space-between;

  padding: 22px 0;

  @media (max-width: 960px) {
    padding: 0;
  }
}

.nauta-faq-detail-item {
  margin-top: 48px;

  h2 {
    color: #333;
    font-family: "Work Sans";
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
  }

  p {
    margin-top: 16px;
    color: #646363;
    font-family: "Work Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
  }
}

.nauta-faq-detail-navigation-help{
  font-size: 16px;
  font-weight: 500;
  line-height: 100%;
  color: #646363;

  &:hover{
    cursor: pointer;
  }
}

.help-modal::v-deep .primary-button {
  background-color: #29BA5F !important;
}

</style>
